import {CorrectionReportDetail} from 'api/gen/CorrectionReportDetail';

import {convertApcReportToTripleAttributeValue} from './convert-apc-report-to-triple-attribute-value';
import {ApcReportFormValues} from '../components/apc-report-form/form-values';

/**
 * Converts correction-report detail data into the APC form value shape.
 *
 * @param report Correction-report detail loaded for editing.
 * @returns APC form values ready for form initialization.
 */
export const convertCorrectionReportToFormValues = (report: CorrectionReportDetail): ApcReportFormValues => ({
    correctionType: report.correctionType,
    earTag: report.earTag,
    technicianNumber: report.technicianNumber,
    milkKg: report.milkKg,
    proficiencyTestDate: report.proficiencyTestDate,
    updatedEarTag: report.updatedEarTag,
    stableNumber: report.stableCode,
    milkingTripleAttribute: convertApcReportToTripleAttributeValue(report),
    lactosePercentage: report.lactosePercentage,
    somaticCells: report.somaticCells,
    urea: report.urea,
    fatPercentage: report.fatPercentage,
    proteinPercentage: report.proteinPercentage,
});
